export const nationalities_es = [
  {
    alpha2: 'AD',
    value: 'AND',
    display: 'Andorra',
  },
  {
    alpha2: 'AE',
    value: 'ARE',
    display: 'Emiratos Árabes Unidos',
  },
  {
    alpha2: 'AF',
    value: 'AFG',
    display: 'Afganistán',
  },
  {
    alpha2: 'AG',
    value: 'ATG',
    display: 'Antigua y Barbuda',
  },
  {
    alpha2: 'AI',
    value: 'AIA',
    display: 'Anguila',
  },
  {
    alpha2: 'AL',
    value: 'ALB',
    display: 'Albania',
  },
  {
    alpha2: 'AM',
    value: 'ARM',
    display: 'Armenia',
  },
  {
    alpha2: 'AO',
    value: 'AGO',
    display: 'Angola',
  },
  {
    alpha2: 'AQ',
    value: 'ATA',
    display: 'Antártida',
  },
  {
    alpha2: 'AR',
    value: 'ARG',
    display: 'Argentina',
  },
  {
    alpha2: 'AS',
    value: 'ASM',
    display: 'Samoa Americana',
  },
  {
    alpha2: 'AT',
    value: 'AUT',
    display: 'Austria',
  },
  {
    alpha2: 'AU',
    value: 'AUS',
    display: 'Australia',
  },
  {
    alpha2: 'AW',
    value: 'ABW',
    display: 'Aruba',
  },
  {
    alpha2: 'AX',
    value: 'ALA',
    display: 'Åland Islands',
  },
  {
    alpha2: 'AZ',
    value: 'AZE',
    display: 'Azerbaiyán',
  },
  {
    alpha2: 'BA',
    value: 'BIH',
    display: 'Bosnia y Herzegovina',
  },
  {
    alpha2: 'BB',
    value: 'BRB',
    display: 'Barbados',
  },
  {
    alpha2: 'BD',
    value: 'BGD',
    display: 'Bangladés',
  },
  {
    alpha2: 'BE',
    value: 'BEL',
    display: 'Bélgica',
  },
  {
    alpha2: 'BF',
    value: 'BFA',
    display: 'Burkina Faso',
  },
  {
    alpha2: 'BG',
    value: 'BGR',
    display: 'Bulgaria',
  },
  {
    alpha2: 'BH',
    value: 'BHR',
    display: 'Baréin',
  },
  {
    alpha2: 'BI',
    value: 'BDI',
    display: 'Burundi',
  },
  {
    alpha2: 'BJ',
    value: 'BEN',
    display: 'Benín',
  },
  {
    alpha2: 'BL',
    value: 'BLM',
    display: 'San Bartolomé',
  },
  {
    alpha2: 'BM',
    value: 'BMU',
    display: 'Bermudas',
  },
  {
    alpha2: 'BN',
    value: 'BRN',
    display: 'Brunéi Darussalam',
  },
  {
    alpha2: 'BO',
    value: 'BOL',
    display: 'Bolivia',
  },
  {
    alpha2: 'BQ',
    value: 'BES',
    display: 'Bonaire',
  },
  {
    alpha2: 'BR',
    value: 'BRA',
    display: 'Brasil',
  },
  {
    alpha2: 'BS',
    value: 'BHS',
    display: 'Bahamas',
  },
  {
    alpha2: 'BT',
    value: 'BTN',
    display: 'Bután',
  },
  {
    alpha2: 'BV',
    value: 'BVT',
    display: 'Isla Bouvet',
  },
  {
    alpha2: 'BW',
    value: 'BWA',
    display: 'Botsuana',
  },
  {
    alpha2: 'BY',
    value: 'BLR',
    display: 'Bielorrusia',
  },
  {
    alpha2: 'BZ',
    value: 'BLZ',
    display: 'Belice',
  },
  {
    alpha2: 'CA',
    value: 'CAN',
    display: 'Canadá',
  },
  {
    alpha2: 'CC',
    value: 'CCK',
    display: 'Islas Cocos',
  },
  {
    alpha2: 'CD',
    value: 'COD',
    display: 'Congo, Democratic Republic of the',
  },
  {
    alpha2: 'CF',
    value: 'CAF',
    display: 'República Centroafricana',
  },
  {
    alpha2: 'CG',
    value: 'COG',
    display: 'Congo',
  },
  {
    alpha2: 'CH',
    value: 'CHE',
    display: 'Suiza',
  },
  {
    alpha2: 'CI',
    value: 'CIV',
    display: 'Costa de Marfil',
  },
  {
    alpha2: 'CK',
    value: 'COK',
    display: 'Islas Cook',
  },
  {
    alpha2: 'CL',
    value: 'CHL',
    display: 'Chile',
  },
  {
    alpha2: 'CM',
    value: 'CMR',
    display: 'Camerún',
  },
  {
    alpha2: 'CN',
    value: 'CHN',
    display: 'China',
  },
  {
    alpha2: 'CO',
    value: 'COL',
    display: 'Colombia',
  },
  {
    alpha2: 'CR',
    value: 'CRI',
    display: 'Costa Rica',
  },
  {
    alpha2: 'CU',
    value: 'CUB',
    display: 'Cuba',
  },
  {
    alpha2: 'CV',
    value: 'CPV',
    display: 'Cabo Verde',
  },
  {
    alpha2: 'CW',
    value: 'CUW',
    display: 'Curaçao',
  },
  {
    alpha2: 'CX',
    value: 'CXR',
    display: 'Isla de Navidad',
  },
  {
    alpha2: 'CY',
    value: 'CYP',
    display: 'Chipre',
  },
  {
    alpha2: 'CZ',
    value: 'CZE',
    display: 'República Checa',
  },
  {
    alpha2: 'DE',
    value: 'DEU',
    display: 'Alemania',
  },
  {
    alpha2: 'DJ',
    value: 'DJI',
    display: 'Yibuti',
  },
  {
    alpha2: 'DK',
    value: 'DNK',
    display: 'Dinamarca',
  },
  {
    alpha2: 'DM',
    value: 'DMA',
    display: 'Dominica',
  },
  {
    alpha2: 'DO',
    value: 'DOM',
    display: 'República Dominicana',
  },
  {
    alpha2: 'DZ',
    value: 'DZA',
    display: 'Argelia',
  },
  {
    alpha2: 'EC',
    value: 'ECU',
    display: 'Ecuador',
  },
  {
    alpha2: 'EE',
    value: 'EST',
    display: 'Estonia',
  },
  {
    alpha2: 'EG',
    value: 'EGY',
    display: 'Egipto',
  },
  {
    alpha2: 'EH',
    value: 'ESH',
    display: 'Sahara Occidental',
  },
  {
    alpha2: 'ER',
    value: 'ERI',
    display: 'Eritrea',
  },
  {
    alpha2: 'ES',
    value: 'ESP',
    display: 'España',
  },
  {
    alpha2: 'ET',
    value: 'ETH',
    display: 'Etiopía',
  },
  {
    alpha2: 'FI',
    value: 'FIN',
    display: 'Finlandia',
  },
  {
    alpha2: 'FJ',
    value: 'FJI',
    display: 'Fiyi',
  },
  {
    alpha2: 'FK',
    value: 'FLK',
    display: 'Islas Malvinas',
  },
  {
    alpha2: 'FM',
    value: 'FSM',
    display: 'Micronesia',
  },
  {
    alpha2: 'FO',
    value: 'FRO',
    display: 'Islas Feroe',
  },
  {
    alpha2: 'FR',
    value: 'FRA',
    display: 'Francia',
  },
  {
    alpha2: 'GA',
    value: 'GAB',
    display: 'Gabón',
  },
  {
    alpha2: 'GB',
    value: 'GBR',
    display: 'Reino Unido',
  },
  {
    alpha2: 'GD',
    value: 'GRD',
    display: 'Granada',
  },
  {
    alpha2: 'GE',
    value: 'GEO',
    display: 'Georgia',
  },
  {
    alpha2: 'GF',
    value: 'GUF',
    display: 'Guayana Francesa',
  },
  {
    alpha2: 'GG',
    value: 'GGY',
    display: 'Guernsey',
  },
  {
    alpha2: 'GH',
    value: 'GHA',
    display: 'Ghana',
  },
  {
    alpha2: 'GI',
    value: 'GIB',
    display: 'Gibraltar',
  },
  {
    alpha2: 'GL',
    value: 'GRL',
    display: 'Groenlandia',
  },
  {
    alpha2: 'GM',
    value: 'GMB',
    display: 'Gambia',
  },
  {
    alpha2: 'GN',
    value: 'GIN',
    display: 'Guinea',
  },
  {
    alpha2: 'GP',
    value: 'GLP',
    display: 'Guadalupe',
  },
  {
    alpha2: 'GQ',
    value: 'GNQ',
    display: 'Guinea Ecuatorial',
  },
  {
    alpha2: 'GR',
    value: 'GRC',
    display: 'Grecia',
  },
  {
    alpha2: 'GS',
    value: 'SGS',
    display: 'Georgia del sur y las islas sandwich del sur',
  },
  {
    alpha2: 'GT',
    value: 'GTM',
    display: 'Guatemala',
  },
  {
    alpha2: 'GU',
    value: 'GUM',
    display: 'Guam',
  },
  {
    alpha2: 'GW',
    value: 'GNB',
    display: 'Guinea-Bisáu',
  },
  {
    alpha2: 'GY',
    value: 'GUY',
    display: 'Guyana',
  },
  {
    alpha2: 'HK',
    value: 'HKG',
    display: 'Hong Kong',
  },
  {
    alpha2: 'HM',
    value: 'HMD',
    display: 'Isla Heard e Islas McDonald',
  },
  {
    alpha2: 'HN',
    value: 'HND',
    display: 'Honduras',
  },
  {
    alpha2: 'HR',
    value: 'HRV',
    display: 'Croacia',
  },
  {
    alpha2: 'HT',
    value: 'HTI',
    display: 'Haití',
  },
  {
    alpha2: 'HU',
    value: 'HUN',
    display: 'Hungría',
  },
  {
    alpha2: 'ID',
    value: 'IDN',
    display: 'Indonesia',
  },
  {
    alpha2: 'IE',
    value: 'IRL',
    display: 'Irlanda',
  },
  {
    alpha2: 'IL',
    value: 'ISR',
    display: 'Israel',
  },
  {
    alpha2: 'IM',
    value: 'IMN',
    display: 'Isla de Man',
  },
  {
    alpha2: 'IN',
    value: 'IND',
    display: 'India',
  },
  {
    alpha2: 'IO',
    value: 'IOT',
    display: 'Territorio Británico del Océano Índico',
  },
  {
    alpha2: 'IQ',
    value: 'IRQ',
    display: 'Irak',
  },
  {
    alpha2: 'IR',
    value: 'IRN',
    display: 'Irán',
  },
  {
    alpha2: 'IS',
    value: 'ISL',
    display: 'Islandia',
  },
  {
    alpha2: 'IT',
    value: 'ITA',
    display: 'Italia',
  },
  {
    alpha2: 'JE',
    value: 'JEY',
    display: 'Jersey',
  },
  {
    alpha2: 'JM',
    value: 'JAM',
    display: 'Jamaica',
  },
  {
    alpha2: 'JO',
    value: 'JOR',
    display: 'Jordania',
  },
  {
    alpha2: 'JP',
    value: 'JPN',
    display: 'Japón',
  },
  {
    alpha2: 'KE',
    value: 'KEN',
    display: 'Kenia',
  },
  {
    alpha2: 'KG',
    value: 'KGZ',
    display: 'Kirguistán',
  },
  {
    alpha2: 'KH',
    value: 'KHM',
    display: 'Camboya',
  },
  {
    alpha2: 'KI',
    value: 'KIR',
    display: 'Kiribati',
  },
  {
    alpha2: 'KM',
    value: 'COM',
    display: 'Comoras',
  },
  {
    alpha2: 'KN',
    value: 'KNA',
    display: 'San Cristóbal y Nieves',
  },
  {
    alpha2: 'KP',
    value: 'PRK',
    display: 'Korea (Democratic Peoples Republic of)',
  },
  {
    alpha2: 'KR',
    value: 'KOR',
    display: 'Corea',
  },
  {
    alpha2: 'KW',
    value: 'KWT',
    display: 'Kuwait',
  },
  {
    alpha2: 'KY',
    value: 'CYM',
    display: 'Islas Caimán',
  },
  {
    alpha2: 'KZ',
    value: 'KAZ',
    display: 'Kazajistán',
  },
  {
    alpha2: 'LA',
    value: 'LAO',
    display: 'Lao',
  },
  {
    alpha2: 'LB',
    value: 'LBN',
    display: 'Líbano',
  },
  {
    alpha2: 'LC',
    value: 'LCA',
    display: 'Santa Lucía',
  },
  {
    alpha2: 'LI',
    value: 'LIE',
    display: 'Liechtenstein',
  },
  {
    alpha2: 'LK',
    value: 'LKA',
    display: 'Sri Lanka',
  },
  {
    alpha2: 'LR',
    value: 'LBR',
    display: 'Liberia',
  },
  {
    alpha2: 'LS',
    value: 'LSO',
    display: 'Lesoto',
  },
  {
    alpha2: 'LT',
    value: 'LTU',
    display: 'Lituania',
  },
  {
    alpha2: 'LU',
    value: 'LUX',
    display: 'Luxemburgo',
  },
  {
    alpha2: 'LV',
    value: 'LVA',
    display: 'Letonia',
  },
  {
    alpha2: 'LY',
    value: 'LBY',
    display: 'Libia',
  },
  {
    alpha2: 'MA',
    value: 'MAR',
    display: 'Marruecos',
  },
  {
    alpha2: 'MC',
    value: 'MCO',
    display: 'Mónaco',
  },
  {
    alpha2: 'MD',
    value: 'MDA',
    display: 'Moldavia',
  },
  {
    alpha2: 'ME',
    value: 'MNE',
    display: 'Montenegro',
  },
  {
    alpha2: 'MF',
    value: 'MAF',
    display: 'San Martín',
  },
  {
    alpha2: 'MG',
    value: 'MDG',
    display: 'Madagascar',
  },
  {
    alpha2: 'MH',
    value: 'MHL',
    display: 'Islas Marshall',
  },
  {
    alpha2: 'MK',
    value: 'MKD',
    display: 'Macedonia',
  },
  {
    alpha2: 'ML',
    value: 'MLI',
    display: 'Malí',
  },
  {
    alpha2: 'MM',
    value: 'MMR',
    display: 'Myanmar',
  },
  {
    alpha2: 'MN',
    value: 'MNG',
    display: 'Mongolia',
  },
  {
    alpha2: 'MO',
    value: 'MAC',
    display: 'Macao',
  },
  {
    alpha2: 'MP',
    value: 'MNP',
    display: 'Islas Marianas del Norte',
  },
  {
    alpha2: 'MQ',
    value: 'MTQ',
    display: 'Martinica',
  },
  {
    alpha2: 'MR',
    value: 'MRT',
    display: 'Mauritania',
  },
  {
    alpha2: 'MS',
    value: 'MSR',
    display: 'Montserrat',
  },
  {
    alpha2: 'MT',
    value: 'MLT',
    display: 'Malta',
  },
  {
    alpha2: 'MU',
    value: 'MUS',
    display: 'Mauricio',
  },
  {
    alpha2: 'MV',
    value: 'MDV',
    display: 'Maldivas',
  },
  {
    alpha2: 'MW',
    value: 'MWI',
    display: 'Malaui',
  },
  {
    alpha2: 'MX',
    value: 'MEX',
    display: 'México',
  },
  {
    alpha2: 'MY',
    value: 'MYS',
    display: 'Malasia',
  },
  {
    alpha2: 'MZ',
    value: 'MOZ',
    display: 'Mozambique',
  },
  {
    alpha2: 'NA',
    value: 'NAM',
    display: 'Namibia',
  },
  {
    alpha2: 'NC',
    value: 'NCL',
    display: 'Nueva Caledonia',
  },
  {
    alpha2: 'NE',
    value: 'NER',
    display: 'Níger',
  },
  {
    alpha2: 'NF',
    value: 'NFK',
    display: 'Isla Norfolk',
  },
  {
    alpha2: 'NG',
    value: 'NGA',
    display: 'Nigeria',
  },
  {
    alpha2: 'NI',
    value: 'NIC',
    display: 'Nicaragua',
  },
  {
    alpha2: 'NL',
    value: 'NLD',
    display: 'Países Bajos',
  },
  {
    alpha2: 'NO',
    value: 'NOR',
    display: 'Noruega',
  },
  {
    alpha2: 'NP',
    value: 'NPL',
    display: 'Nepal',
  },
  {
    alpha2: 'NR',
    value: 'NRU',
    display: 'Nauru',
  },
  {
    alpha2: 'NU',
    value: 'NIU',
    display: 'Niue',
  },
  {
    alpha2: 'NZ',
    value: 'NZL',
    display: 'Nueva Zelanda',
  },
  {
    alpha2: 'OM',
    value: 'OMN',
    display: 'Omán',
  },
  {
    alpha2: 'PA',
    value: 'PAN',
    display: 'Panamá',
  },
  {
    alpha2: 'PE',
    value: 'PER',
    display: 'Perú',
  },
  {
    alpha2: 'PF',
    value: 'PYF',
    display: 'Polinesia Francesa',
  },
  {
    alpha2: 'PG',
    value: 'PNG',
    display: 'Papúa Nueva Guinea',
  },
  {
    alpha2: 'PH',
    value: 'PHL',
    display: 'Filipinas',
  },
  {
    alpha2: 'PK',
    value: 'PAK',
    display: 'Pakistán',
  },
  {
    alpha2: 'PL',
    value: 'POL',
    display: 'Polonia',
  },
  {
    alpha2: 'PM',
    value: 'SPM',
    display: 'San Pedro y Miquelón',
  },
  {
    alpha2: 'PN',
    value: 'PCN',
    display: 'Pitcairn',
  },
  {
    alpha2: 'PR',
    value: 'PRI',
    display: 'Puerto Rico',
  },
  {
    alpha2: 'PS',
    value: 'PSE',
    display: 'Palestina, Estado de',
  },
  {
    alpha2: 'PT',
    value: 'PRT',
    display: 'Portugal',
  },
  {
    alpha2: 'PW',
    value: 'PLW',
    display: 'Palaos',
  },
  {
    alpha2: 'PY',
    value: 'PRY',
    display: 'Paraguay',
  },
  {
    alpha2: 'QA',
    value: 'QAT',
    display: 'Catar',
  },
  {
    alpha2: 'RE',
    value: 'REU',
    display: 'Reunión',
  },
  {
    alpha2: 'RO',
    value: 'ROU',
    display: 'Rumania',
  },
  {
    alpha2: 'RS',
    value: 'SRB',
    display: 'Serbia',
  },
  {
    alpha2: 'RU',
    value: 'RUS',
    display: 'Rusia',
  },
  {
    alpha2: 'RW',
    value: 'RWA',
    display: 'Ruanda',
  },
  {
    alpha2: 'SA',
    value: 'SAU',
    display: 'Arabia Saudita',
  },
  {
    alpha2: 'SB',
    value: 'SLB',
    display: 'Islas Salomón',
  },
  {
    alpha2: 'SC',
    value: 'SYC',
    display: 'Seychelles',
  },
  {
    alpha2: 'SD',
    value: 'SDN',
    display: 'Sudán',
  },
  {
    alpha2: 'SE',
    value: 'SWE',
    display: 'Suecia',
  },
  {
    alpha2: 'SG',
    value: 'SGP',
    display: 'Singapur',
  },
  {
    alpha2: 'SH',
    value: 'SHN',
    display: 'Santa Helena',
  },
  {
    alpha2: 'SI',
    value: 'SVN',
    display: 'Eslovenia',
  },
  {
    alpha2: 'SJ',
    value: 'SJM',
    display: 'Svalbard y Jan Mayen',
  },
  {
    alpha2: 'SK',
    value: 'SVK',
    display: 'Eslovaquia',
  },
  {
    alpha2: 'SL',
    value: 'SLE',
    display: 'Sierra leona',
  },
  {
    alpha2: 'SM',
    value: 'SMR',
    display: 'San Marino',
  },
  {
    alpha2: 'SN',
    value: 'SEN',
    display: 'Senegal',
  },
  {
    alpha2: 'SO',
    value: 'SOM',
    display: 'Somalia',
  },
  {
    alpha2: 'SR',
    value: 'SUR',
    display: 'Surinam',
  },
  {
    alpha2: 'SS',
    value: 'SSD',
    display: 'Sudán del Sur',
  },
  {
    alpha2: 'ST',
    value: 'STP',
    display: 'Santo Tomé y Príncipe',
  },
  {
    alpha2: 'SV',
    value: 'SLV',
    display: 'El Salvador',
  },
  {
    alpha2: 'SX',
    value: 'SXM',
    display: 'Sint Maarten',
  },
  {
    alpha2: 'SY',
    value: 'SYR',
    display: 'Siria',
  },
  {
    alpha2: 'SZ',
    value: 'SWZ',
    display: 'Suazilandia',
  },
  {
    alpha2: 'TC',
    value: 'TCA',
    display: 'Islas Turcas y Caicos',
  },
  {
    alpha2: 'TD',
    value: 'TCD',
    display: 'Chad',
  },
  {
    alpha2: 'TF',
    value: 'ATF',
    display: 'Territorios Australes Franceses',
  },
  {
    alpha2: 'TG',
    value: 'TGO',
    display: 'Togo',
  },
  {
    alpha2: 'TH',
    value: 'THA',
    display: 'Tailandia',
  },
  {
    alpha2: 'TJ',
    value: 'TJK',
    display: 'Tayikistán',
  },
  {
    alpha2: 'TK',
    value: 'TKL',
    display: 'Tokelau',
  },
  {
    alpha2: 'TL',
    value: 'TLS',
    display: 'Timor-Leste',
  },
  {
    alpha2: 'TM',
    value: 'TKM',
    display: 'Turkmenistán',
  },
  {
    alpha2: 'TN',
    value: 'TUN',
    display: 'Túnez',
  },
  {
    alpha2: 'TO',
    value: 'TON',
    display: 'Tonga',
  },
  {
    alpha2: 'TR',
    value: 'TUR',
    display: 'Turquía',
  },
  {
    alpha2: 'TT',
    value: 'TTO',
    display: 'Trinidad y Tobago',
  },
  {
    alpha2: 'TV',
    value: 'TUV',
    display: 'Tuvalu',
  },
  {
    alpha2: 'TW',
    value: 'TWN',
    display: 'Taiwán',
  },
  {
    alpha2: 'TZ',
    value: 'TZA',
    display: 'Tanzania',
  },
  {
    alpha2: 'UA',
    value: 'UKR',
    display: 'Ucrania',
  },
  {
    alpha2: 'UG',
    value: 'UGA',
    display: 'Uganda',
  },
  {
    alpha2: 'UM',
    value: 'UMI',
    display: 'Islas de Ultramar Menores de Estados Unidos',
  },
  {
    alpha2: 'US',
    value: 'USA',
    display: 'Estados Unidos',
  },
  {
    alpha2: 'UY',
    value: 'URY',
    display: 'Uruguay',
  },
  {
    alpha2: 'UZ',
    value: 'UZB',
    display: 'Uzbekistán',
  },
  {
    alpha2: 'VA',
    value: 'VAT',
    display: 'Holy See',
  },
  {
    alpha2: 'VC',
    value: 'VCT',
    display: 'San Vicente y las Granadinas',
  },
  {
    alpha2: 'VE',
    value: 'VEN',
    display: 'Venezuela',
  },
  {
    alpha2: 'VG',
    value: 'VGB',
    display: 'Virgin Islands (British)',
  },
  {
    alpha2: 'VI',
    value: 'VIR',
    display: 'Islas Vírgenes',
  },
  {
    alpha2: 'VN',
    value: 'VNM',
    display: 'Vietnam',
  },
  {
    alpha2: 'VU',
    value: 'VUT',
    display: 'Vanuatu',
  },
  {
    alpha2: 'WF',
    value: 'WLF',
    display: 'Wallis y Futuna',
  },
  {
    alpha2: 'WS',
    value: 'WSM',
    display: 'Samoa',
  },
  {
    alpha2: 'YE',
    value: 'YEM',
    display: 'Yemen',
  },
  {
    alpha2: 'YT',
    value: 'MYT',
    display: 'Mayotte',
  },
  {
    alpha2: 'ZA',
    value: 'ZAF',
    display: 'Sudáfrica',
  },
  {
    alpha2: 'ZM',
    value: 'ZMB',
    display: 'Zambia',
  },
  {
    alpha2: 'ZW',
    value: 'ZWE',
    display: 'Zimbabue',
  },
];
